var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbhaIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4195_3349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 12.5007C11.6668 11.584 10.9168 10.834 10.0002 10.834C9.0835 10.834 8.3335 11.584 8.3335 12.5007C8.3335 13.084 8.66683 13.6673 9.16683 13.9173V15.834H10.8335V13.9173C11.3335 13.6673 11.6668 13.084 11.6668 12.5007Z",
    fill: "#192852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 19.9993C6.3335 19.9993 3.3335 16.9993 3.3335 13.3327C3.3335 9.66602 6.3335 6.66602 10.0002 6.66602C13.6668 6.66602 16.6668 9.66602 16.6668 13.3327C16.6668 16.9993 13.6668 19.9993 10.0002 19.9993ZM10.0002 8.33268C7.25016 8.33268 5.00016 10.5827 5.00016 13.3327C5.00016 16.0827 7.25016 18.3327 10.0002 18.3327C12.7502 18.3327 15.0002 16.0827 15.0002 13.3327C15.0002 10.5827 12.7502 8.33268 10.0002 8.33268Z",
    fill: "#192852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9.16667H13.3333V5C13.3333 3.16667 11.8333 1.66667 10 1.66667C8.16667 1.66667 6.66667 3.16667 6.66667 5V9.16667H5V5C5 2.25 7.25 0 10 0C12.75 0 15 2.25 15 5V9.16667Z",
    fill: "#192852"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4195_3349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbhaIcon3);
export default __webpack_public_path__ + "static/media/abha-icon3.f8678ac685a0d0b29c82a2cdbbd97603.svg";
export { ForwardRef as ReactComponent };